import React from 'react'
import { LinkToPropertyMapBase } from './styles'
import Link from 'src/comps/Link'

interface ILinkToProperty {
  readonly propertyId: string
  readonly country: string
  readonly citySlug: string
  readonly children: React.ReactNode
}

export function LinkToPropertyMap({ propertyId, country, citySlug, children }: ILinkToProperty) {
  return (
    <Link
      page="map"
      query={{ country, type: 'city', slug: citySlug, highlightedProperty: propertyId }}
      target="_blank"
      rel="noopener"
    >
      <LinkToPropertyMapBase>{children}</LinkToPropertyMapBase>
    </Link>
  )
}
